import { render, staticRenderFns } from "./CopyInvitation.vue?vue&type=template&id=244aea12&"
import script from "./CopyInvitation.vue?vue&type=script&lang=js&"
export * from "./CopyInvitation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports